export default __webpack_public_path__ + "static/media/key.e70ae329.svg";